import styled from "styled-components";

export const NavBackContainer = styled.div`
  padding-top: 8px;
`;
